/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PharmacyCounselorPharmacistTypename = "PharmacyCounselorPharmacist" as const;

/**
 *
 * @export
 * @interface PharmacyCounselorPharmacist
 */
export interface PharmacyCounselorPharmacist {
  /**
   *
   * @type {number}
   * @memberof PharmacyCounselorPharmacist
   */
  chainId?: number;
  /**
   *
   * @type {string}
   * @memberof PharmacyCounselorPharmacist
   */
  chainName?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyCounselorPharmacist
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyCounselorPharmacist
   */
  firstName: string;
  /**
   *
   * @type {number}
   * @memberof PharmacyCounselorPharmacist
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof PharmacyCounselorPharmacist
   */
  lastName: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyCounselorPharmacist
   */
  pharmacyEmail: string;
  /**
   *
   * @type {number}
   * @memberof PharmacyCounselorPharmacist
   */
  pharmacyId: number;
  /**
   *
   * @type {string}
   * @memberof PharmacyCounselorPharmacist
   */
  pharmacyName: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyCounselorPharmacist
   */
  readonly __typename?: string;
}

export function PharmacyCounselorPharmacistFromJSON(json: any): PharmacyCounselorPharmacist {
  return PharmacyCounselorPharmacistFromJSONTyped(json, false);
}

export function PharmacyCounselorPharmacistFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyCounselorPharmacist {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyCounselorPharmacistTypename,

    chainId: !exists(json, "chain_id") ? undefined : json["chain_id"],
    chainName: !exists(json, "chain_name") ? undefined : json["chain_name"],
    email: !exists(json, "email") ? undefined : json["email"],
    firstName: json["first_name"],
    id: json["id"],
    lastName: json["last_name"],
    pharmacyEmail: json["pharmacy_email"],
    pharmacyId: json["pharmacy_id"],
    pharmacyName: json["pharmacy_name"],
  };
}

export function PharmacyCounselorPharmacistToJSON(object?: PharmacyCounselorPharmacist | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    chain_id: value.chainId,
    chain_name: value.chainName,
    email: value.email,
    first_name: value.firstName,
    id: value.id,
    last_name: value.lastName,
    pharmacy_email: value.pharmacyEmail,
    pharmacy_id: value.pharmacyId,
    pharmacy_name: value.pharmacyName,
  };
}
